import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './Login.css'; // Add your styles here
import bimage from "./img/bimage.png";
import autodesk from "./img/autodesk.png";
import { showToast } from './toastUtils';
import { queuedApiFetch, apiFetch } from './api';

function Login({ onLoginSuccess }) {
  const [searchParams] = useSearchParams();
  const getID = searchParams.get('id');
  const id = searchParams.get('id');
  const code = searchParams.get('code');
  //console.log('the code is :', code);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [step, setStep] = useState(1); // Step 1: Email, Step 2: Password
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  //older code

  // useEffect(()=>{
  //   if(getID){
  //     handleLogin()
  //   }
  // },[getID])

  useEffect(() => {
    validateLogin();
  }, []);

  const validateLogin = async () => {
    if (!id || !code) return;

    const formattedData = {
      email_id: id,
      code: code,
    };

    const requestOptions = {
      method: 'POST',
      // headers: {
      //   'Content-Type': 'application/json',
      //   // 'ngrok-skip-browser-warning': '69420',
      // },
      body: JSON.stringify(formattedData),
    };

    try {
      const response = await queuedApiFetch(`/user/login_validate`, requestOptions);
      const result = await response;
      // console.log('Login validation result:', result);
      if (
        result.apistatus?.Status_Code === 200 &&
        result.apistatus?.Status_Description?.toLowerCase() === 'success'
      ) {
        handleLogin();
      } else {
        showToast.error('Something went wrong. Please try again later');
        // console.warn('Login not allowed:', result);
      }
    } catch (error) {
      // console.error('API error:', error);
    } finally {
    }
  };


  
  //newer code
  // useEffect(() => {
  //   if (getID) {
  //     const isLoggedIn = localStorage.getItem('isLoggedIn');
  //     const hostname = window.location.hostname;
  //     if (isLoggedIn) {
  //       handleLogin();
  //     }
  //   }
  // }, [getID]);
    
  

  const handleNext = (event) => {
    event.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      // alert('Please enter a valid email address.');
      showToast.error('Please enter a valid email address.');
      return;
    }

    // if (email.toLowerCase().includes('@nus')) {
    //   // Redirect if email contains @nus
    //   window.location.href = "https://nus.vmwareidentity.asia/SAAS/auth/federation/sso";
    //   return;
    // }

    if (email.toLowerCase().includes('@nus') || email.toLowerCase().includes('.nus')) {
      // Redirect if email contains @nus
      window.location.href = "https://nus.vmwareidentity.asia/SAAS/auth/federation/sso?redirecturl="+process.env.REACT_APP_BACKEND_URL;
      return;
    }

    // Proceed to the next step if the email is valid and does not contain @nus
    setStep(2);
  };

  // const handleLogin = (event) => {
  //   if (!loading) {
  //     setLoading(true);
  //     event.preventDefault();
  //     const requestOptions = {
  //       method: 'GET',
  //       //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
  //     };
  //     queuedApiFetch('/user/checkuser?emailid=' + email, requestOptions)
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
  //           localStorage.setItem('accountId', data.data.bim360_account_id);
  //           localStorage.setItem('userEmail', email);
  //           localStorage.setItem('userDetails', JSON.stringify(data.data));
  //           onLoginSuccess();
  //           navigate('/homeacc');
  //           setLoading(false);
  //         } else {
  //           // alert('Invalid User');
  //           showToast.error('Invalid User');
  //         }
  //       })
  //       .catch((error) => console.error('Error fetching data:', error))
  //       .finally(() => setLoading(false));
  //   }
  // };

  const handleLogin = async () => { 
    if (!loading) {
      setLoading(true);
      // event.preventDefault();
  
      const requestOptions = {
        method: 'GET',
        //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
      };
  
      try {
        const response = await queuedApiFetch(`/user/checkuser?emailid=${getID}`, //email
          requestOptions
        );
        const data = await response;
  
        if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
          localStorage.setItem('accountId', data.data.bim360_account_id);
          localStorage.setItem('userEmail', getID);         
          localStorage.setItem('userDetails', JSON.stringify(data.data));
          onLoginSuccess();
          localStorage.setItem('lastActiveRoute', '/homeacc');
          navigate('/homeacc');
        } else {
          showToast.error('Invalid User');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    }
  };
  
  return (
    <div className="login-container">
      <div className="login-content">
        {/* <div className="login-box">
          <div className="login-page-header">User Login</div>
          <form
            id="loginForm"
            onSubmit={step === 1 ? handleNext : handleLogin}
          >
            {step === 1 && (
              <>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                  required
                />
                <button type="submit" className="login-button">Next</button>
              </>
            )}
            {step === 2 && (
              <>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  required
                />
                <button
                  type="submit"
                  disabled={loading ? true : false}
                  className="login-button"
                >
                  {loading ? 'Loading...' : 'Sign in'}
                </button>
              </>
            )}
          </form>                    
        </div> */}

<button disabled={loading ? true : false} onClick={()=>{ window.location.href = process.env.REACT_APP_BACKEND_URL+'/autodesk/signin'}} type="submit" style={{width : '20%'}} className="login-button">{loading ? 'Loading...' : 'Login Via Autodesk'}</button>
        {/* <button
          disabled={loading}
          onClick={() => {
            const fullHost = window.location.host;
            const subdomain = fullHost.includes('-') ? fullHost.split('-')[0] : '';
            console.log('Subdomain:', subdomain);
            const baseUrl = process.env.REACT_APP_BACKEND_URL + '/autodesk/signin';
            const finalUrl = subdomain
              ? `${baseUrl}?host=${encodeURIComponent(subdomain)}`
              : baseUrl;

            window.location.href = finalUrl;
          }}
          type="submit"
          style={{ width: '20%' }}
          className="login-button"
        >
          {loading ? 'Loading...' : 'Login Via Autodesk'}
        </button> */}

        <div className="footerlogo">
          <div className="footerlogogroup">
            Developed and Maintained by
            <img src={bimage} alt="BIMAGE" />
          </div>
          <div className="footerlogogroup">
            Powered by
            <img src={autodesk} alt="Autodesk" />
          </div>
        </div>
      </div>

      <div className="copyright">
        © 2024 BIMAGE Consulting. All rights reserved.
      </div>
    </div>
  );
}

export default Login;
